export default "__VITE_ASSET__B0e39A4___"